<template>
<!-- if route != home add class "test" -->
  
  <div class="cp-main" :class=" loggedIn ? 'header-top' : '' ">
    <HeaderComponent></HeaderComponent>
    <CustomMenu></CustomMenu>
    <transition>
      <div class="min-height">
        <router-view></router-view>
      </div>
    </transition>
    <FooterComponent></FooterComponent>
<!--    <cookie-consent :buttonLabel="$t('Okay')"
    :href="'/information/cookie-policy'"
    :target="'_blank'"
    :rel="''"
    :message="$t('This website uses cookies to ensure a better user experience. By continuing on the site, you accept the use of cookies. Learn more')"
    :linkLabel="$t('Cookie Policy')"
    :cookieExpiryDays="1">
    </cookie-consent>-->
  </div>
  
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import HeaderComponent from './components/layouts/Header';
import CustomMenu from './components/layouts/CustomMenu';
import FooterComponent from './components/layouts/Footer';
// import CookieConsent from 'vue-cookieconsent-component'

export default {
  name: 'app',
  metaInfo: {
    title: 'Renkaatalle',
    titleTemplate: '%s - Renkaatalle'
  },
  components: {
    /*CookieConsent,*/
    HeaderComponent,
    CustomMenu,
    FooterComponent
  },
  data(){
    return{
      appName: process.env.VUE_APP_NAME
    }
  },
  async created() {
    if (localStorage.getItem('service') == null) {
      localStorage.setItem("service", '1');
    }
    if ("GoogleAddress" in localStorage) {
      await this.searchServicePoints();
      this.setDefaultServicePoint();
    }

    /*await this.getAppointmentCached();
    if (this.appointmentCached != null && (new Date(this.appointmentCached.schedule_date)).getTime() < (new Date()).getTime()) {
      this.removeOlderAppointment();
      this.setAppointmentCached(null);
      localStorage.removeItem("appointment");
      this.csRemoveDealerFromLocalStorage();
      this.csWORemoveDealerFromLocalStorage();
    }*/

  },
  computed: {
        ...mapGetters('auth', ['loggedIn']),
        ...mapGetters('app', ['currentLang']),
        ...mapGetters('cart', ['cartData', 'priceDetail']),
        ...mapGetters('appointments', ['appointmentCached']),
  },
  methods : {
      ...mapActions('search_by_service_point', ['searchServicePoints', 'setDefaultServicePoint', 'removeOlderAppointment']),
      ...mapActions('cart_right_sidebar', ['csRemoveDealerFromLocalStorage', 'csWORemoveDealerFromLocalStorage']),
      ...mapActions('appointments', ['getAppointmentCached', 'setAppointmentCached']),
  },
  mounted() {
    if (process.env.VUE_APP_INCLUDE_META_PIXEL === 'true') {
      fbq('track', 'Home');
    }
    this.klaviyoIdentifyUser();
  }

}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

.cookie-consent-compliance {
  background: #1494d2 !important;
  border: 2px solid #1494d2 !important;
}
</style>